import React, { Component } from "react";
import {
    Typography,
    Table,
    TableCell,
    TableRow,
    TableHead,
    TableBody,
    Checkbox,
    FormControlLabel,
} from "@material-ui/core";
import "./style.css";

import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";

const GreenCheckbox = withStyles({
    root: {
        color: green[400],
        "&$checked": {
            color: green[600],
        },
        "&$disabled": {
            color: "#ddd",
        },
    },
    checked: {},
    disabled: {},
})((props) => <Checkbox color="default" {...props} />);

export default class TableData extends Component {
    constructor(props) {
        super(props);
        this.state = { reportNotPresent: false };
    }
    render() {
        const { tableData, setSetting, currUserType } = this.props;

        return (
            <div
                style={{
                    maxHeight: 550,
                    overflow: "auto",
                }}
            >
                <Table id="table" stickyHeader aria-label="sticky table">
                    <TableHead id="head" style={{ position: "sticky" }}>
                        <TableRow>
                            <TableHeader text="Title" />
                            <TableHeader text="Create" />
                            <TableHeader text="Read" />
                            <TableHeader text="Update" />
                            <TableHeader text="Delete" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableData &&
                            tableData.map((e, i) => {
                                return (
                                    <TableRow key={i}>
                                        <TableCell>{e.title}</TableCell>
                                        <TableCell>
                                            <CheckBox
                                                disabled={
                                                    currUserType === "Users" &&
                                                    [
                                                        "machine_manager",
                                                        "equipment_manager",
                                                        "user_manager",
                                                    ].includes(e.key)
                                                }
                                                value={e.create ? true : false}
                                                handleChange={(event) => {
                                                    if (
                                                        typeof e.create !==
                                                        "undefined"
                                                    )
                                                        setSetting(
                                                            i,
                                                            e.key,
                                                            "create",
                                                            event.target.checked
                                                        );
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <CheckBox
                                                disabled={
                                                    typeof e.read ===
                                                    "undefined"
                                                        ? true
                                                        : false
                                                }
                                                value={e.read}
                                                handleChange={(event) => {
                                                    if (
                                                        typeof e.read !==
                                                        "undefined"
                                                    )
                                                        setSetting(
                                                            i,
                                                            e.key,
                                                            "read",
                                                            event.target.checked
                                                        );
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <CheckBox
                                                style={{
                                                    opacity:
                                                        typeof e.update ===
                                                        "undefined"
                                                            ? ".3"
                                                            : "1",
                                                }}
                                                disabled={
                                                    typeof e.update ===
                                                    "undefined"
                                                        ? true
                                                        : false
                                                }
                                                value={e.update}
                                                handleChange={(event) => {
                                                    if (
                                                        typeof e.update !==
                                                        "undefined"
                                                    )
                                                        setSetting(
                                                            i,
                                                            e.key,
                                                            "update",
                                                            event.target.checked
                                                        );
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <CheckBox
                                                disabled={
                                                    currUserType === "Users" &&
                                                    [
                                                        "machine_manager",
                                                        "equipment_manager",
                                                        "user_manager",
                                                    ].includes(e.key)
                                                }
                                                style={{
                                                    opacity:
                                                        typeof e.delete ===
                                                        "undefined"
                                                            ? ".3"
                                                            : "1",
                                                }}
                                                value={e.delete}
                                                handleChange={(event) => {
                                                    if (
                                                        typeof e.delete !==
                                                        "undefined"
                                                    )
                                                        setSetting(
                                                            i,
                                                            e.key,
                                                            "delete",
                                                            event.target.checked
                                                        );
                                                }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </div>
        );
    }
}
const CheckBox = (props) => {
    return (
        <FormControlLabel
            control={
                <GreenCheckbox
                    style={props.style}
                    disabled={props.disabled}
                    checked={props.value}
                    onChange={props.handleChange}
                />
            }
        />
    );
};
const TableHeader = (props) => {
    return (
        <TableCell>
            <Typography variant="body2">
                <b>{props.text}</b>
            </Typography>
        </TableCell>
    );
};
